/**
 * 接口请求映射关系，默认post请求
 * 配置本地mock数据：OM0001: 'mock|/zs-miaocang-web/api/user/login'  功能暂未实现
 * 配置get 请求：OM0001: 'get|/zs-miaocang-web/api/user/login'
 *
 * mock数据统一配置在项目根目录mock/api下
 */
const mc = '/zs-miaocangapp-web'
export default {
    /**
     * 系统相关、登出登入相关
     */
    getPlaceInfo: mc+'/api/area/getProvinceCityAndArea',//获取城市、省份、城镇
    scanCard: mc+'/api/user/scanCard',//返回身份证图片识别信息
    scanCertificate: mc+'/api/company/scanCertificate',//返回身份证图片识别信息
    checkLoginMobile: mc+'/api/user/check_mobile',//检查手机号是否已注册
    doLogin: mc+'/api/user/pwdLogin',//登录
    doSmsLogin: mc+'/api/user/smsLogin',//短信登录
    logout: mc+'/api/user/logout',//退出登录
    getVerifyCode: mc+'/api/user/sendSmsCode',//获取验证码
    wxLogin: mc+'/api/user/wxLogin',//微信登录
    wxBindMobile: mc+'/api/user/wxBindMobile',//微信绑定手机号
    doReg: mc+'/api/user/regMember',//注册
    qrCodeLogin: mc+'/api/user/qrCodeLogin',//二维码登录 //
    /**
     * 用户相关
     */
    uCenter: mc+'/api/user/getUserInfo',//用户中心
    modifyMemberInfo: mc+'/api/user/modifyMemberInfo',//修改用户信息
    authRealName: mc+'/api/user/authRealName',//个人认证
    getAuthRealNameInfo: mc+'/api/user/getAuthRealNameInfo',//认证信息
    reAuthMember: mc+'/api/user/reviewMemberAuthStatus',//重新申请认证
    changePassword: mc+'/api/user/changePassword',//修改密码
    changeAvatar: mc+'/api/user/updateAvatar',//修改头像
    getUserIntegral: mc+'/api/user/getUserIntegral',//用户最新积分
    /**
     * 公司相关
     */
    getCompanyInfo: mc+'/api/company/getCompanyBriefProfile',//获取公司基本信息
    childAccountList: mc+'/api/company/getSubAccountList',//获取子账号列表
    updateCompanyBriefProfile: mc+'/api/company/updateCompanyBriefProfile',//修改企业基本信息
    addCompanyCertInfo: mc+'/api/company/addCompanyCertInfo',//修改企业认证信息
    getCompanyCertInfo: mc+'/api/company/getCompanyCertInfo',//获取企业认证信息
    reAuthCompany: mc+'/api/company/reviewCompanyAuthStatus',//重新申请认证
    updateCompanyLogo: mc+'/api/company/updateCompanyLogo',//更换企业logo
    /**
     * warehouse api
     */
    warehouseList: mc+'/api/warehouse/findWarehouseList',//苗圃列表
    addWarehouse: mc+'/api/warehouse/addWarehouse',//添加苗圃
    getTreeList: mc+'/api/sku/getSkuSeedlingList',//获取仓内苗木列表
    exportSkuSeedling: mc+'/api/sku/exportSkuSeedling',//苗木导出
    editWarehouse: mc+'/api/warehouse/editWarehouse',//编辑苗圃
    warehouseInfo: mc+'/api/warehouse/getWarehouse',//苗圃信息
    deleteWarehouse: mc+'/api/warehouse/deleteWarehouse',//删除苗圃
    quickUpdateWarehouse: mc+'/api/sku/oneKeyUpdate',//一键更新
    /* 库存盘点 */
    stockTakingRuleList: mc+'/api/rule/ruleList',//盘点规则列表
    stockTakingRuleUpdate: mc+'/api/rule/updateRule',//盘点规则保存
    stockTakingAlertCount: mc+'/api/rule/typeList',//盘点提醒数
    stockTakingAlertList: mc+'/api/rule/getRemindSeedlingList',//盘点苗木列表

    /**
     * tree api
     */
    searchSuggest: mc+'/api/sku/searchBybaseName', //关键字搜索苗木
    getSeedlingParam: mc+'/api/sku/getNameConf',//获取苗木规格
    addTree: mc+'/api/sku/addSkuSeedling',//添加苗木
    deleteTree: mc+'/api/sku/deleteSeedling',//删除苗木
    batchDeleteSeedling: mc+'/api/sku/batchDeleteSeedling',//批量删除苗木
    getTreeDetail: mc+'/api/sku/getSkuSeedling',//获取苗木详情
    editTree: mc+'/api/sku/editSkuSeedling',//编辑苗木
    quickUpdate: mc+'/api/sku/quickUpdate',//调价模式/快速修改
    /*导入商品相关*/
    excelSeedlingImportDo: mc+'/api/sku/batchimport',//excel批量导入
    downloadImportFailedRecord: mc+'/api/sku/exportUploadRecord',//excel批量导入
    excelSeedlingImportHistory: mc+'/api/sku/batchImportList',//excel批量导入历史
    batchImportRemoveImg: mc+'/api/sku/batchimport/removeImg',//移除批量上传时已上传的临时图片
    /*营销推广相关*/
    getSpecialSeedlingsList: mc+'/api/adv/getSpecialSeedlingsList',//获取营销推广中的商品列表
    getCouldSetSpecialSeedlingList: mc+'/api/adv/getNeedSetSpecialSeedlingList',//推广状态(精品或清货)设置可设置列表
    setSeedlingSaleType: mc+'/api/adv/setSeedlingNeedSaleType',//推广状态(精品或清货)设置
    getSeedlingAdvFee: mc+'/api/adv/getSeedlingAdvfee',//广告消耗配置
    setSeedlingAdv: mc+'/api/adv/setSeedlingAdv',//设置广告

    /**苗讯相关  */
    getInfoTypeList: mc+'/api/info/getInfoTypeList', // 获取资讯分类
    getInfoList: mc+'/api/info/getInfoList', // 获取资讯列表
    getInfoDetails: mc+'/api/info/getInfo', // 获取资讯详情
    addInfoViewCount: mc+'/api/info/addInfoViewCount', // 增加浏览量
    












}



// WEBPACK FOOTER //
// ./src/api/interface.js